import { z } from 'zod';

import {
    createDeleteSchema,
    createUpdateSchemaFromAdd,
    optionalBoolean,
    optionalString,
    requiredNumber,
    requiredString,
    requiredUuid,
} from './fields';
import { SYNC_UPDATE_VALIDATION_SCHEMA } from './common';

export const createEventContactsAddSchema = () =>
    z.object({
        id: requiredUuid(),
        created_at: requiredNumber(),
        updated_at: requiredNumber(),
        event_id: requiredUuid(),
        contact_id: requiredUuid(),
        user_id: requiredUuid(),
        organisation_id: requiredUuid(),
        sent_sms: optionalBoolean(),
        sent_sms_at: requiredString(),
        sent_email: optionalBoolean(),
        sent_email_at: requiredString(),
        status: optionalString(),
    });

export const createEventContactsUpdateSchema = () =>
    createUpdateSchemaFromAdd(
        createEventContactsAddSchema(),
        SYNC_UPDATE_VALIDATION_SCHEMA.event_contacts,
    );

export const createEventContactsDeleteSchema = () => createDeleteSchema();

export const createEventContactsSchemas = () => ({
    add: createEventContactsAddSchema(),
    update: createEventContactsUpdateSchema(),
    delete: createEventContactsDeleteSchema(),
});
